__turbopack_context__.v({
  "className": "libre_barcode_39_7ef53309-module__0RLAGG__className",
});
